const matchPercent = value => /(\d+\.?\d*)%/g.exec(value);

export default matchPercent;
